// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"CountryModal_labelContainer__3j6Km","label":"CountryModal_label__3aUQy","h2":"CountryModal_h2__2QxuU","selected":"CountryModal_selected__1jLrh"};